/* Predictive search — debounced product suggestions in the header dropdown.
   Fetches the `predictive-search` section HTML from routes.predictive_search_url and injects it.
   Progressive enhancement: without JS the form still submits to /search (full results page). */
(function () {
  var root = document.querySelector('[data-predictive-search]');
  if (!root) return;

  var input = root.querySelector('[data-search-input]');
  var results = root.querySelector('[data-predictive-results]');
  var toggle = root.querySelector('[data-search-toggle]');
  var closeBtn = root.querySelector('[data-search-close]');
  var predictiveUrl = root.getAttribute('data-predictive-url') || '/search/suggest';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 250;
  var timer = null;
  var lastQuery = '';
  var controller = null;

  function openResults() {
    results.hidden = false;
    root.classList.add('is-active');
    input.setAttribute('aria-expanded', 'true');
  }

  function closeResults() {
    results.hidden = true;
    root.classList.remove('is-active');
    input.setAttribute('aria-expanded', 'false');
  }

  function fetchResults(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = predictiveUrl +
      '?q=' + encodeURIComponent(term) +
      '&section_id=predictive-search' +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last';
    results.setAttribute('aria-busy', 'true');
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        results.removeAttribute('aria-busy');
        if (!text) return;
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('#shopify-section-predictive-search');
        results.innerHTML = section ? section.innerHTML : text;
        openResults();
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') results.removeAttribute('aria-busy');
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);
    if (term.length < MIN_CHARS) {
      if (controller) controller.abort();
      lastQuery = '';
      results.innerHTML = '';
      results.removeAttribute('aria-busy');
      closeResults();
      return;
    }
    if (term === lastQuery) { openResults(); return; }
    lastQuery = term;
    timer = setTimeout(function () { fetchResults(term); }, DEBOUNCE_MS);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= MIN_CHARS && results.innerHTML) openResults();
  });

  // Close on outside click.
  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) closeResults();
  });

  // Escape closes the dropdown; on mobile it also collapses the field.
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeResults();
      if (root.classList.contains('is-open')) collapseMobile();
      else input.blur();
    }
  });

  // Arrow keys move focus through the suggestion links.
  root.addEventListener('keydown', function (e) {
    if (results.hidden) return;
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = Array.prototype.slice.call(results.querySelectorAll('a'));
    if (!links.length) return;
    e.preventDefault();
    var idx = links.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') (links[idx + 1] || links[0]).focus();
    else (idx <= 0 ? input : links[idx - 1]).focus();
  });

  // Mobile: the magnifier icon expands the field into an overlay.
  function expandMobile() {
    root.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input.focus(); }, 60);
  }
  function collapseMobile() {
    root.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    closeResults();
  }
  if (toggle) {
    toggle.addEventListener('click', function () {
      if (root.classList.contains('is-open')) collapseMobile();
      else expandMobile();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      if (controller) controller.abort();
      input.value = '';
      lastQuery = '';
      results.innerHTML = '';
      results.removeAttribute('aria-busy');
      closeResults();
      if (root.classList.contains('is-open')) collapseMobile();
      else input.focus();
    });
  }
})();
